/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { ListTable, Icon, Link, Tip, Group, Copy, Title } from '@insticator/insticator-ui'; // iui-material
//utils
import paymenttypemap from 'pages/dashboard/account/paymentinfo/paymenttypemap';
import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/paymentinfo/existingpayments/existingpayments_styles';



/* ========== ~~~~~~~~~~ ACCOUNT EXISTING PAYMENTS ~~~~~~~~~~ ========== */
class ExistingPayments extends Component {
    constructor(props){
        super(props);
        this.paymentUUIDNames= {
            CHECK: 'checkUUID',
            ACH: 'achUUID',
            PAYPAL: 'paypalUUID',
            WIRE: 'wireTransferUUID'
        }
    }
    handleTableData = () => {
        let dataArray = [];
        // changed this from map to forEach since we're not technically mapping anything here
        this.props.paymentInfo.forEach((item, index) => {
            if(item.paymentType !== 'NONE') dataArray.push({
                method: paymenttypemap[item.paymentType],
                lastupdate: item.lastUpdate,
                preferred: `${item.preferredPayment ? 'Yes' : 'No'}`,
                edit: <div className={`editcolumn`}><Link type={`action`} text={`Details`} color={`primary`} icon={`eye`} action={()=>this.handlePaymentTypeEdit(item.paymentType, item[this.paymentUUIDNames[item.paymentType]])} /></div>
            })
        });
        return dataArray;
    };
    handlePaymentTypeEdit = (paymentType, paymentUUID) => {
        //👎🏻this is here because check is the only payment type that doesnt match the paymentType name (CHECKS vs CHECK) 👎🏻
        this.props.changePaymentType(paymentType === 'CHECK' ? 'CHECKS' : paymentType, paymentUUID);
        this.props.moveToPage(`dashboard/account/paymentinfo/enterinformation`);
    };

    handleAddPayment = () => this.props.moveToPage(`dashboard/account/paymentinfo/selectmethod`);

    render() {
        return(
            <div className={`existingpayments ${this.props.classes.existingpayments}`}>
                <Copy name={`page-copy`}>
                    <Title variant={'withctas'}>
                        <h2>Payment Information </h2>
                        {this.props.savedPaymentTypes.length < 4 &&
                        <Group name={`controls`}>
                            <PaymentInfoCTAs primaryButtonText={'Add Payment Method'} primaryAction={this.handleAddPayment} />
                        </Group>}
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <ListTable
                        name={`paymentmethod`}
                        type={`fixed-column`}
                        fixedColWidth={200}
                        size={`full`}
                        columnHeads={{
                            method: 'Payment Method',
                            lastupdate: 'Last Update',
                            preferred: <span>Preferred <Tip space={`none`} content={<p>This is the method that Insticator will use to pay you.</p>}/></span>,
                            edit: ''
                        }}
                        data={this.handleTableData()}
                        rowsPerPage={'general'}
                        paginationLocation={`bottom`}
                    />
                </Group>
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ExistingPayments);
